import { instrumentGroup } from '../shared/holding-groups';
import type { InstrumentDto } from '../shared/types';

const logoSymbols: Record<string, ReadonlySet<string>> = {
  TH_EQUITY: new Set(['TISCO', 'ADVANC', 'PTT', 'CPALL', 'AOT', 'BDMS']),
  US_EQUITY: new Set(['AAPL', 'MSFT', 'NVDA', 'GOOGL', 'KO', 'JNJ']),
  GOLD: new Set(['XAU']),
  CRYPTO: new Set(['BTC']),
};
const logoFiles: Record<string, string> = { BTC: 'btc.png', XAU: 'xau.png' };
const automaticLogoKinds = new Set(['TH_EQUITY', 'US_EQUITY', 'ETF']);

export function assetLogoSources(instrument: InstrumentDto) {
  const symbol = instrument.symbol.toUpperCase();
  const market = instrumentGroup(instrument);
  const local = logoSymbols[market]?.has(symbol)
    ? [`/logos/${logoFiles[symbol] || `${symbol.toLowerCase()}.svg`}`]
    : [];
  return automaticLogoKinds.has(instrument.kind)
    ? [...local, `/api/instruments/${encodeURIComponent(instrument.id)}/logo`]
    : local;
}
